var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGraphicdesign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 221.275,
    height: 167,
    viewBox: "0 0 221.275 167",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "graphicdesign",
    transform: "translate(-380.43 -310)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_98",
    "data-name": "Group 98",
    transform: "translate(380.43 310)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M585.005,316.471A10.24,10.24,0,0,1,595.234,326.7V460.3a10.24,10.24,0,0,1-10.229,10.229H397.13A10.24,10.24,0,0,1,386.9,460.3V326.7a10.24,10.24,0,0,1,10.229-10.229H585.005m0-6.471H397.13a16.7,16.7,0,0,0-16.7,16.7V460.3a16.7,16.7,0,0,0,16.7,16.7H585.005a16.7,16.7,0,0,0,16.7-16.7V326.7a16.7,16.7,0,0,0-16.7-16.7Z",
    transform: "translate(-380.43 -310)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_36",
    "data-name": "Line 36",
    d: "M-11.077,106.662h0A2.923,2.923,0,0,1-14,103.737l.083-114.817A2.922,2.922,0,0,1-10.992-14a2.923,2.923,0,0,1,2.92,2.925l-.083,114.817A2.923,2.923,0,0,1-11.077,106.662Z",
    transform: "translate(44.661 15.299)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M440.328,678.526a3.432,3.432,0,1,1-3.432,3.432,3.432,3.432,0,0,1,3.432-3.432m0-3.966a7.4,7.4,0,1,0,7.4,7.4,7.407,7.407,0,0,0-7.4-7.4Z",
    transform: "translate(-421.971 -598.458)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_37",
    "data-name": "Line 37",
    d: "M-11.078,19.828A2.922,2.922,0,0,1-14,16.905V-11.077A2.922,2.922,0,0,1-11.078-14a2.922,2.922,0,0,1,2.922,2.922V16.905A2.922,2.922,0,0,1-11.078,19.828Z",
    transform: "translate(44.745 145.955)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_103",
    "data-name": "Group 103",
    transform: "translate(438.774 356.965)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M659.92,603.37v44.735h19.449V603.37Zm15.56,39.224H664.458V608.881H675.48Z",
    transform: "translate(-659.92 -589.094)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M799.238,577.987a6.471,6.471,0,1,1,6.288-8l46.487-.154-.027-3.083L798.2,534.98l-27.687,14.4v44.645l29.1,14.03,52.352-31.615v-2.879l-46.56-.054A6.476,6.476,0,0,1,799.238,577.987Zm9.922,1.4,28.943-1.236-39.456,22.758-22.631-10.6-.184-37,22.046-11.995,40.606,23.793-29.273-1.4a12.468,12.468,0,1,0-.052,15.677Z",
    transform: "translate(-747.424 -534.98)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_111",
    "data-name": "Group 111",
    transform: "translate(508.551 330.466)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M999.76,531.945c-2.009,0-3.267-.094-3.465-.11a2.3,2.3,0,0,1,.367-4.578c.191.015,19.24,1.4,33.274-7.992,10.264-6.868,27.406-22.39,26.9-49.185-.553-28.99-17.054-43.77-30.8-51.065-13.845-7.348-25.632-6.337-25.75-6.326a2.3,2.3,0,0,1-.431-4.572c.535-.05,13.286-1.144,28.333,6.842,14.834,7.873,32.642,23.811,33.237,55.034.573,30.059-20.043,47.141-28.933,53.09C1020.725,530.954,1006.284,531.945,999.76,531.945Z",
    transform: "translate(-994.184 -408.039)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_38",
    "data-name": "Line 38",
    d: "M-7.552,101.593a2.3,2.3,0,0,1-2.3-2.272L-11-8.679A2.3,2.3,0,0,1-8.728-11,2.3,2.3,0,0,1-6.408-8.728l1.152,108a2.3,2.3,0,0,1-2.272,2.321Z",
    transform: "translate(73.092 18.722)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M1287.32,696.806a4.727,4.727,0,1,1,3.563-1.618A4.721,4.721,0,0,1,1287.32,696.806Z",
    transform: "translate(-1222.389 -629.044)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M1283.35,684.438a3.683,3.683,0,1,1-2.776,1.261,3.671,3.671,0,0,1,2.776-1.261m0-2.088h0a5.772,5.772,0,1,0,3.793,1.424,5.772,5.772,0,0,0-3.793-1.424Z",
    transform: "translate(-1218.417 -625.088)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M1290.333,970.1a4.727,4.727,0,1,1,3.566-1.618A4.721,4.721,0,0,1,1290.333,970.1Z",
    transform: "translate(-1224.772 -845.284)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M1286.37,957.727a3.683,3.683,0,1,1-2.776,1.261,3.671,3.671,0,0,1,2.776-1.261m0-2.087h0a5.771,5.771,0,1,0,3.8,1.424,5.771,5.771,0,0,0-3.8-1.424Z",
    transform: "translate(-1220.807 -841.328)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M1284.51,423.516a4.727,4.727,0,1,1,3.563-1.618A4.722,4.722,0,0,1,1284.51,423.516Z",
    transform: "translate(-1220.166 -412.803)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M1280.54,411.148a3.683,3.683,0,1,1-2.776,1.261,3.671,3.671,0,0,1,2.776-1.261m0-2.088h0a5.772,5.772,0,1,0,3.793,1.424,5.772,5.772,0,0,0-3.793-1.424Z",
    transform: "translate(-1216.194 -408.847)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphicdesign);
export default __webpack_public_path__ + "static/media/graphicdesign.0b5450bc02676f53a7de6f6f7a3c6ea4.svg";
export { ForwardRef as ReactComponent };